export default __webpack_public_path__ + "static/media/47_3_0.7db6b114.png";